/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import moment from 'moment';
import Map from '../../components/MapOld';
import { isEmpty, isNull } from 'underscore';
import Layout from '../../components/layout/Layout';
import FilterSidebar from '../../components/FilterSidebar';
import dayjs from 'dayjs';
import { requestMarkerDetails, setMarkerPopoverToLoading } from '../../core/utils/mapUtils';

import './journeyView.scss';

const { GOOGLE_MAP_API_KEY, DB_DATETIME_FORMAT } = require('../../core/constants').default;

export default function () {
    const { selectedJourney, isFetching, user } = this.props;
    const { sliderValue, centerMap, markerPopover, sidebarIsOpen } = this.state;

    const mappedDevicePath = this.mapDevicePath();
    const startArea = (selectedJourney && selectedJourney.info && selectedJourney.info.start_area_address) || null;
    const endArea = (selectedJourney && selectedJourney.info && selectedJourney.info.end_area_address) || null;
    const journeyStart = selectedJourney && selectedJourney.info && selectedJourney.info.start ? moment(selectedJourney.info.start, DB_DATETIME_FORMAT).format('DD/MM/YYYY HH:mm:ss') : '[not-set]';
    const journeyEnd = selectedJourney && selectedJourney.info && selectedJourney.info.end ? moment(selectedJourney.info.end, DB_DATETIME_FORMAT).format('DD/MM/YYYY HH:mm:ss') : '[not-set]';
    const mapToolBarButtons = [
        { key: 'side-bar', visible: false },
        { key: 'info-box', visible: true },
        { key: 'traffic', visible: false },
        { key: 'geo-fence', visible: false },
        { key: 'center-map', visible: false },
        { key: 'satellite', visible: true },
        { key: 'heat-map', visible: false },
        { key: 'live-map', visible: false },
        { key: 'video-search', visible: false },
    ];
    const assets = this.getAssetCurrentPin(mappedDevicePath);
    let score = 0;
    let startInterval = 0;
    let endInterval = 0;
    if (!isEmpty(selectedJourney)) {
        score = selectedJourney.info.score;
        startInterval = selectedJourney.startInterval;
        endInterval = selectedJourney.endInterval;
    }
    let asset_picture = '';
    if (selectedJourney && selectedJourney.info) {
        asset_picture = (
            <img
                className="journey-asset-image"
                alt={selectedJourney.info.registration || '[not-set]'}
                src={selectedJourney.info.asset_picture || user?.userCompany?.company_image} />
        );
    }
    const isLoading = isFetching || !selectedJourney || isNull(selectedJourney);

    return (
        <Layout
            data-test="pages-journey-view"
            className="events-view"
            title={<div>Journey View</div>}
            headerTitle={<div>Journey View</div>}
            showFooter={false}
            loading={isLoading}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar 
                    displayFilter={sidebarIsOpen}
                    onToggleFilterSidebar={this.toggleSidebar}
                    overrideTitle='Asset & Driver Info'
                >
                    <Row>
                        <Col span={24}>
                            <br />
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <img
                                    alt="Asset"
                                    src={
                                        selectedJourney?.info?.asset_picture ?
                                            selectedJourney.info.asset_picture :
                                            user?.userCompany?.company_image
                                    }
                                    style={{ width: 160, height: 160 }}
                                />
                            </div>
                            <br />
                            <div style={{ textAlign: 'left', marginLeft: 16 }}>
                                <Link to={`/assets/view/${selectedJourney?.info?.asset_id}`}>
                                    {selectedJourney?.info?.name && selectedJourney?.info?.registration 
                                        ? `${selectedJourney?.info?.name} [${selectedJourney?.info?.registration}]`
                                        : '-'
                                    }
                                </Link>
                                <br />
                                <br />
                                <span style={{
                                    fontSize: '12px',
                                    color: 'var(--cool-gray-60)',
                                    fontWeight: 600,
                                }}>
                                    Last Service:
                                </span>
                                &ensp;
                                {selectedJourney?.info?.last_service
                                    ? dayjs(selectedJourney.info.last_service).format('DD/MM/YYYY')
                                    : '-'
                                }
                                <br />
                                <br />
                                <Link to={`/drivers/view/${selectedJourney?.info?.user_id}`}>{selectedJourney?.info?.driver}</Link>
                            </div>
                        </Col>
                        <Col span={24}>
                            <br />
                            <br />
                            <br />
                            <div style={{ width: '80%', marginLeft: '16px' }}>
                                <span className='filter-title' style={{ left: 16 }}>Journey Info</span>
                                <br />
                                <br />
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>Start Date</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>{journeyStart}</span>
                                    </Col>
                                </Row>
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>Start Area</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>
                                            {startArea}
                                        </span>
                                    </Col>
                                </Row>
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>End Date</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>{journeyEnd}</span>
                                    </Col>
                                </Row>
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>End Area</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>
                                            {endArea}
                                        </span>
                                    </Col>
                                </Row>
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>Journey Score</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>{selectedJourney?.info?.score}</span>
                                    </Col>
                                </Row>
                                <br />
                                <Row className="video-view-info-row">
                                    <Col xs={10}>
                                        <span className='label'>Events</span>
                                    </Col>
                                    <Col xs={14}>
                                        <span className='value'>{selectedJourney?.info?.events}</span>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </FilterSidebar>
                <div
                    className="content"
                    style={{ 
                        opacity: isLoading ? 0 : 1,
                        height: '95vh',
                    }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body" style={{ height: 'calc(100vh - 48px)', overflow: 'hidden' }}>
                                <br />
                                <Row
                                    gutter={40}
                                    type="flex"
                                    justify="space-between"
                                    className="data-row map-row"
                                    style={{ 
                                        width: '99%',
                                        marginLeft: '4px',
                                    }}
                                >
                                    <Col 
                                        xl={24} 
                                        style={{ height: '87vh' }}
                                    >
                                        <Map
                                            ref={this.googleMapAccess}
                                            markerOnClick={this.markerOnClick}
                                            markerOnMouseEnter={(marker) => { setMarkerPopoverToLoading(this); requestMarkerDetails(marker, this); }}
                                            markerPopover={markerPopover}
                                            mapDate={moment().subtract('1', 'days').format('DD/MM/YYYY')}
                                            apiKey={GOOGLE_MAP_API_KEY}
                                            mapToolBarButtons={mapToolBarButtons}
                                            sliderStep={1}
                                            sliderValue={parseInt(sliderValue, 10)}
                                            sliderMinValue={startInterval}
                                            sliderMaxValue={endInterval}
                                            sliderValueUnit="seconds"
                                            hideDatePicker
                                            center={centerMap}
                                            onSliderChange={this.updateSliderValue}
                                            assets={assets}
                                            allowStreetView
                                            showFindCenterButton={false}
                                            path={mappedDevicePath} 
                                            overrideSliderKey={sidebarIsOpen ? 'slider_sidebar-open' : 'slider_sidebar-closed'}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
